import SocialSharingLinks from "@modules/study/common/social_sharing_links";
import API from "@unisearch/helpers/api";
import { htmlParse } from "@unisearch/helpers/utils";
import dynamic from "next/dynamic";
import { Fragment, useEffect, useState } from "react";
import styles from "./study_why_country_intro.module.scss";
const LeadForm = dynamic(() => import("@modules/lead/components/form"), {
  ssr: false,
});
const UniComment = dynamic(() => import("@modules/study/common/comment"), {
  ssr: false,
});
const baseUrl = process.env.NEXT_PUBLIC_URL;

export const StudyWhyCountryIntro = ({ pageData, name, linkType }) => {
  const [formData, setFormData] = useState();

  const fetchData = async () => {
    const res = await API.get(`public/lead-contact-form/pages/popup`);
    if (res && !res.error) {
      setFormData(res.data);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const LeadFormComponent = ({ className }) => {
    return (
      <>
        {formData && (
          <div
            className={`lead_form_insidepage_wrapper ${
              className?.root ? className?.root : ""
            }`}
          >
            <div className="lead_form_insidepage_heading_wrapper">
              <h3 className="">
                Want to study abroad? Sign up with{" "}
                <span className={"color-orange"}>UniSearch!</span>
              </h3>
              <p className="">
                Jumpstart your study abroad dreams with UniSearch
              </p>
            </div>
            <LeadForm
              showTitle={false}
              showSubTitle={false}
              pageData={formData}
              buttonTitle="Submit"
              pageSlug={formData?.slug}
            />
          </div>
        )}
      </>
    );
  };

  let contentFirst;
  let contentLast;
  const isShortCodeFormExist =
    pageData &&
    pageData?.pageContent &&
    pageData?.pageContent?.includes("[shortcode_form]");

  if (isShortCodeFormExist) {
    const text = pageData?.pageContent.split("[shortcode_form]");
    contentFirst = text[0];
    contentLast = text[1];
  }

  return (
    <section className={styles.section_intro}>
      <div className="container">
        <div
          className={`flex lg:flex-row flex-col gap-7 max-w-[900px] mx-auto w-full`}
        >
          <div className={`flex gap-7`}>
            <div className={`${styles.social_wrapper} sticky top-[170px]`}>
              <SocialSharingLinks
                url={`${baseUrl}/${linkType}/${name}/${pageData?.slug}`}
                title={pageData?.pageTitle}
                className={styles.social_link_wrapper}
              />
            </div>
            <div>
              {pageData?.pageContent && (
                <Fragment>
                  <div className="from_texteditor_wrapper">
                    {isShortCodeFormExist ? (
                      <>
                        {
                          <>
                            {htmlParse(contentFirst)}
                            <LeadFormComponent
                              className={{
                                root: "!my-8",
                              }}
                            />
                            {htmlParse(contentLast)}
                          </>
                        }
                      </>
                    ) : (
                      <>{htmlParse(pageData?.pageContent)}</>
                    )}
                  </div>

                  {/* lead form */}
                  <LeadFormComponent />

                  <div>
                    <script
                      async
                      src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1690314786863972"
                      crossorigin="anonymous"
                    ></script>
                    <ins
                      class="adsbygoogle"
                      style={{ display: "block" }}
                      data-ad-format="autorelaxed"
                      data-ad-client="ca-pub-1690314786863972"
                      data-ad-slot="5945244324"
                    ></ins>
                    <script>
                      {`(adsbygoogle = window.adsbygoogle || []).push({});`}
                    </script>
                  </div>

                  {/* comment */}
                  <div className={styles.uni_comment}>
                    <UniComment
                      commentType="page"
                      referenceId={pageData?.pageId}
                    />
                  </div>
                </Fragment>
              )}
            </div>
          </div>

          {/* {process.env.NEXT_PUBLIC_COMPONENT_ISHIDDEN !== "true" && (
            <div className="shrink-0 self-start flex justify-center w-full lg:w-auto">
              <Advertisement
                width={300}
                height={600}
                src="/temp/add-column-md.png"
                className="!mb-0"
              />
            </div>
          )} */}
        </div>
        {/* {process.env.NEXT_PUBLIC_MAINTENANCE_MODE === "true" && <UniComment />} */}
      </div>
    </section>
  );
};

export default StudyWhyCountryIntro;
